{
  "Accessibility Menu": "ადაპტირებული მენიუ",
  "Reset settings": "პარამეტრების დაბრუნება",
  "Close": "დახურვა",
  "Content Adjustments": "შიგთავსის მორგება",
  "Adjust Font Size": "ფონტის ზომის მორგება",
  "Highlight Title": "სათაურების გამოყოფა",
  "Highlight Links": "ბმულების გამოყოფა",
  "Readable Font": "წაკითხვადი ტექსტები",
  "Color Adjustments": "ფერების მორგება",
  "Dark Contrast": "ბნელი ელფერი",
  "Light Contrast": "ნათელი ელფერი",
  "High Contrast": "მაღალი ელფერი",
  "High Saturation": "მაღალი გაჯერება",
  "Low Saturation": "დაბალი გაჯერება",
  "Monochrome": "ერთფეროვანი გამოსახულება",
  "Contrast": "კონტრასტი",
  "Invert Colors": "ფერების ინვერსია",
  "Tools": "ხელსაწყოები",
  "Reading Guide": "კითხვის გამყოლი ზოლი",
  "Stop Animations": "ანიმაციების გაჩერება",
  "Big Cursor": "დიდი კურსორი",
  "Increase Font Size": "ფონტის ზომის გაზრდა",
  "Decrease Font Size": "ფონტის ზომის შემცირება",
  "Letter Spacing": "ასოებს შორის დაშორება",
  "Line Height": "ხაზის სიმაღლე",
  "Font Weight": "ფონტის წონა",
  "Dyslexia Font": "დისლექსიური ფონტი",
  "Language": "ენა",
  "Open Accessibility Menu": "გახსენი ადაპტირებული მენიუ",
  "Widget Settings": "ვიდჯეტის პარამეტრები",
  "Widget Position": "ვიდჯეტის მდებარეობა",
  "Top Left": "ზედა მარცხენა",
  "Top Center": "ზედა ცენტრი",
  "Top Right": "ზედა მარჯვენა",
  "Center Left": "ცენტრი მარცხენა",
  "Center Right": "ცენტრი მარჯვენა",
  "Bottom Left": "ქვედა მარცხენა",
  "Bottom Center": "ქვედა ცენტრი",
  "Bottom Right": "ქვედა მარჯვენა",
  "Screen Reader": "ეკრანის ამკითხველი",
  "Voice Navigation": "ხმის ნავიგაცია",
  "Custom Color": "მორგებული ფერი",
  "Change the site's colors": "შეცვალეთ საიტის ფერები",
  "Backgrounds": "ფონები",
  "Headings": "სათაურები",
  "Contents": "შინაარსი",
  "Reset colors": "ფერების განულება",
  "Image Desaturation": "სურათის გაუფერულება",
  "Search languages": "ენების ძიება",
  "No languages found": "ენები ვერ მოიძებნა",
  "Accessibility Profiles": "ხელმისაწვდომობის პროფილები",
  "Motor Impaired": "მოძრაობის შეზღუდვა",
  "Big cursor, voice navigation, and no animations.": "დიდი კურსორი, ხმოვანი ნავიგაცია და ანიმაციების გარეშე.",
  "Blind": "უსინათლო",
  "Screen reader helpers with higher contrast.": "ეკრანის მკითხველის დამხმარეები მაღალი კონტრასტით.",
  "Color Blind": "ფერთა სიბრმავე",
  "High contrast palette with desaturated media.": "მაღალი კონტრასტის პალიტრა და ნაკლებად გაჯერებული მედია.",
  "Dyslexia": "დიზლექსია",
  "Friendly font, extra spacing, stronger weight.": "კომფორტული შრიფტი, დამატებითი ინტერვალი და გამკვრივებული ხაზები.",
  "Low vision": "სუსტი მხედველობა",
  "Dark contrast and 130% magnification.": "მუქი კონტრასტი და 130%-იანი გადიდება.",
  "Cognitive & Learning": "კოგნიტური და სწავლა",
  "Highlights key sections and enables voice help.": "გამოკვეთს მთავარ ნაწილებს და აძლიერებს ხმოვან დახმარებას.",
  "Seizure & Epileptic": "კრუნჩხვები და ეპილეფსია",
  "Stops animations and desaturates imagery.": "წყვეტს ანიმაციებს და აკლებს ფერს გამოსახულებებს.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "კითვის გზამკვლევი, გამოკვეთილი ბმულები და მშვიდი ფერები.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
